var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a923a92c1f09dbe0d254c0496eba2fe003dac901"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["circular-react@circular-exchange"]={id:"a923a92c1f09dbe0d254c0496eba2fe003dac901"};
      